import React from "react";
import ReactDOM from "react-dom/client";

import duration from "dayjs/plugin/duration";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import weekOfYear from "dayjs/plugin/weekOfYear";

import { history } from "./history";

import { Provider } from "react-redux";

import dayjs from "dayjs";
import { ErrorBoundary } from "react-error-boundary";

import CustomRouter from "./components/Router";

import { store } from "./configureStore";

import "antd/dist/reset.css";

import "./i18n";

import GlobalStyles from "./styled";
import LoadingIndicator from "./components/LoadingIndicator";
import LocaleProvider from "./LocaleProvider";
import ThemeModeProvider from "./theme/ThemeModeProvider";

dayjs.extend(duration);
dayjs.extend(quarterOfYear);
dayjs.extend(weekOfYear);

const logError = (error: Error) => {
  console.error(error);
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ErrorBoundary onError={logError} fallback={<div />}>
    <Provider store={store}>
      <CustomRouter history={history}>
        <GlobalStyles />
        <ThemeModeProvider>
          <React.Suspense fallback={<LoadingIndicator fullPage />}>
            <LocaleProvider />
          </React.Suspense>
        </ThemeModeProvider>
      </CustomRouter>
    </Provider>
  </ErrorBoundary>,
);
